// @generated by protoc-gen-es v1.8.0 with parameter "target=ts"
// @generated from file gitpod/v1/insights.proto (package gitpod.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3, protoInt64, Timestamp } from "@bufbuild/protobuf";
import { DateRange, Resolution } from "./usage_pb.js";

/**
 * CoAuthorTool identifies the AI tool that co-authored a commit.
 * UNSPECIFIED (0) is the proto default and must not appear in reported data.
 * Use HUMAN for commits with no AI co-author.
 *
 * @generated from enum gitpod.v1.CoAuthorTool
 */
export enum CoAuthorTool {
  /**
   * @generated from enum value: CO_AUTHOR_TOOL_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Commit has no Co-authored-by trailer at all (solo commit).
   *
   * @generated from enum value: CO_AUTHOR_TOOL_NO_COAUTHOR = 1;
   */
  NO_COAUTHOR = 1,

  /**
   * Commit has a Co-authored-by trailer, but the co-author is human.
   *
   * @generated from enum value: CO_AUTHOR_TOOL_HUMAN_COAUTHOR = 2;
   */
  HUMAN_COAUTHOR = 2,

  /**
   * Ona agent.
   *
   * @generated from enum value: CO_AUTHOR_TOOL_ONA = 3;
   */
  ONA = 3,

  /**
   * GitHub Copilot.
   *
   * @generated from enum value: CO_AUTHOR_TOOL_GITHUB_COPILOT = 4;
   */
  GITHUB_COPILOT = 4,

  /**
   * Cursor.
   *
   * @generated from enum value: CO_AUTHOR_TOOL_CURSOR = 5;
   */
  CURSOR = 5,

  /**
   * An AI tool not in the known list.
   *
   * @generated from enum value: CO_AUTHOR_TOOL_OTHER = 6;
   */
  OTHER = 6,
}
// Retrieve enum metadata with: proto3.getEnumType(CoAuthorTool)
proto3.util.setEnumType(CoAuthorTool, "gitpod.v1.CoAuthorTool", [
  { no: 0, name: "CO_AUTHOR_TOOL_UNSPECIFIED" },
  { no: 1, name: "CO_AUTHOR_TOOL_NO_COAUTHOR" },
  { no: 2, name: "CO_AUTHOR_TOOL_HUMAN_COAUTHOR" },
  { no: 3, name: "CO_AUTHOR_TOOL_ONA" },
  { no: 4, name: "CO_AUTHOR_TOOL_GITHUB_COPILOT" },
  { no: 5, name: "CO_AUTHOR_TOOL_CURSOR" },
  { no: 6, name: "CO_AUTHOR_TOOL_OTHER" },
]);

/**
 * CommitCoAuthorStat represents co-author data for a single commit.
 *
 * @generated from message gitpod.v1.CommitCoAuthorStat
 */
export class CommitCoAuthorStat extends Message<CommitCoAuthorStat> {
  /**
   * SHA of the commit. Used with project_id as the idempotency key.
   *
   * @generated from field: string commit_hash = 1;
   */
  commitHash = "";

  /**
   * Author date of the commit.
   *
   * @generated from field: google.protobuf.Timestamp commit_date = 2;
   */
  commitDate?: Timestamp;

  /**
   * Which tool co-authored this commit, NO_COAUTHOR for solo commits,
   * or HUMAN_COAUTHOR for human pair-programming.
   * UNSPECIFIED is rejected — callers must always set a concrete value.
   *
   * @generated from field: gitpod.v1.CoAuthorTool tool = 3;
   */
  tool = CoAuthorTool.UNSPECIFIED;

  /**
   * Lines added in this commit.
   *
   * @generated from field: int64 lines_added = 4;
   */
  linesAdded = protoInt64.zero;

  /**
   * Lines removed in this commit.
   *
   * @generated from field: int64 lines_removed = 5;
   */
  linesRemoved = protoInt64.zero;

  /**
   * One-way hash of the author email. Enables distinct author counts
   * without storing PII.
   *
   * @generated from field: string author_hash = 6;
   */
  authorHash = "";

  /**
   * Raw co-author email address from the Co-authored-by trailer.
   * Empty when there is no co-author trailer. Stored verbatim so the
   * backend can reclassify historical data when new AI tools are added.
   *
   * @generated from field: string raw_coauthor = 7;
   */
  rawCoauthor = "";

  constructor(data?: PartialMessage<CommitCoAuthorStat>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CommitCoAuthorStat";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "commit_hash", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "commit_date", kind: "message", T: Timestamp },
    { no: 3, name: "tool", kind: "enum", T: proto3.getEnumType(CoAuthorTool) },
    { no: 4, name: "lines_added", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 5, name: "lines_removed", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 6, name: "author_hash", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "raw_coauthor", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CommitCoAuthorStat {
    return new CommitCoAuthorStat().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CommitCoAuthorStat {
    return new CommitCoAuthorStat().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CommitCoAuthorStat {
    return new CommitCoAuthorStat().fromJsonString(jsonString, options);
  }

  static equals(a: CommitCoAuthorStat | PlainMessage<CommitCoAuthorStat> | undefined, b: CommitCoAuthorStat | PlainMessage<CommitCoAuthorStat> | undefined): boolean {
    return proto3.util.equals(CommitCoAuthorStat, a, b);
  }
}

/**
 * ReportCoAuthorStatsRequest is sent by the CLI to push analysis results.
 *
 * @generated from message gitpod.v1.ReportCoAuthorStatsRequest
 */
export class ReportCoAuthorStatsRequest extends Message<ReportCoAuthorStatsRequest> {
  /**
   * Project that was analyzed.
   *
   * @generated from field: string project_id = 1;
   */
  projectId = "";

  /**
   * Per-commit co-author stats to upsert.
   *
   * @generated from field: repeated gitpod.v1.CommitCoAuthorStat stats = 2;
   */
  stats: CommitCoAuthorStat[] = [];

  constructor(data?: PartialMessage<ReportCoAuthorStatsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ReportCoAuthorStatsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "project_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "stats", kind: "message", T: CommitCoAuthorStat, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ReportCoAuthorStatsRequest {
    return new ReportCoAuthorStatsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ReportCoAuthorStatsRequest {
    return new ReportCoAuthorStatsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ReportCoAuthorStatsRequest {
    return new ReportCoAuthorStatsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ReportCoAuthorStatsRequest | PlainMessage<ReportCoAuthorStatsRequest> | undefined, b: ReportCoAuthorStatsRequest | PlainMessage<ReportCoAuthorStatsRequest> | undefined): boolean {
    return proto3.util.equals(ReportCoAuthorStatsRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.ReportCoAuthorStatsResponse
 */
export class ReportCoAuthorStatsResponse extends Message<ReportCoAuthorStatsResponse> {
  /**
   * Number of rows inserted (new commits).
   *
   * @generated from field: int64 inserted_count = 1;
   */
  insertedCount = protoInt64.zero;

  /**
   * Number of rows updated (re-reported commits).
   *
   * @generated from field: int64 updated_count = 2;
   */
  updatedCount = protoInt64.zero;

  constructor(data?: PartialMessage<ReportCoAuthorStatsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ReportCoAuthorStatsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "inserted_count", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "updated_count", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ReportCoAuthorStatsResponse {
    return new ReportCoAuthorStatsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ReportCoAuthorStatsResponse {
    return new ReportCoAuthorStatsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ReportCoAuthorStatsResponse {
    return new ReportCoAuthorStatsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ReportCoAuthorStatsResponse | PlainMessage<ReportCoAuthorStatsResponse> | undefined, b: ReportCoAuthorStatsResponse | PlainMessage<ReportCoAuthorStatsResponse> | undefined): boolean {
    return proto3.util.equals(ReportCoAuthorStatsResponse, a, b);
  }
}

/**
 * GetCoAuthorStatsRequest is used by the dashboard to read aggregated stats.
 *
 * @generated from message gitpod.v1.GetCoAuthorStatsRequest
 */
export class GetCoAuthorStatsRequest extends Message<GetCoAuthorStatsRequest> {
  /**
   * Project to query stats for.
   *
   * @generated from field: string project_id = 1;
   */
  projectId = "";

  /**
   * Date range to query within.
   *
   * @generated from field: gitpod.v1.DateRange date_range = 2;
   */
  dateRange?: DateRange;

  /**
   * Time resolution for the time series. Defaults to WEEKLY if unspecified.
   *
   * @generated from field: gitpod.v1.Resolution resolution = 3;
   */
  resolution = Resolution.UNSPECIFIED;

  constructor(data?: PartialMessage<GetCoAuthorStatsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetCoAuthorStatsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "project_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "date_range", kind: "message", T: DateRange },
    { no: 3, name: "resolution", kind: "enum", T: proto3.getEnumType(Resolution) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetCoAuthorStatsRequest {
    return new GetCoAuthorStatsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetCoAuthorStatsRequest {
    return new GetCoAuthorStatsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetCoAuthorStatsRequest {
    return new GetCoAuthorStatsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetCoAuthorStatsRequest | PlainMessage<GetCoAuthorStatsRequest> | undefined, b: GetCoAuthorStatsRequest | PlainMessage<GetCoAuthorStatsRequest> | undefined): boolean {
    return proto3.util.equals(GetCoAuthorStatsRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.GetCoAuthorStatsResponse
 */
export class GetCoAuthorStatsResponse extends Message<GetCoAuthorStatsResponse> {
  /**
   * Summary totals for the requested date range.
   *
   * @generated from field: gitpod.v1.CoAuthorSummary summary = 1;
   */
  summary?: CoAuthorSummary;

  /**
   * Time series of contribution stats, bucketed by the requested resolution.
   *
   * @generated from field: repeated gitpod.v1.CoAuthorTimeBucket time_series = 2;
   */
  timeSeries: CoAuthorTimeBucket[] = [];

  constructor(data?: PartialMessage<GetCoAuthorStatsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetCoAuthorStatsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "summary", kind: "message", T: CoAuthorSummary },
    { no: 2, name: "time_series", kind: "message", T: CoAuthorTimeBucket, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetCoAuthorStatsResponse {
    return new GetCoAuthorStatsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetCoAuthorStatsResponse {
    return new GetCoAuthorStatsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetCoAuthorStatsResponse {
    return new GetCoAuthorStatsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetCoAuthorStatsResponse | PlainMessage<GetCoAuthorStatsResponse> | undefined, b: GetCoAuthorStatsResponse | PlainMessage<GetCoAuthorStatsResponse> | undefined): boolean {
    return proto3.util.equals(GetCoAuthorStatsResponse, a, b);
  }
}

/**
 * CoAuthorSummary contains aggregate totals for a date range.
 *
 * @generated from message gitpod.v1.CoAuthorSummary
 */
export class CoAuthorSummary extends Message<CoAuthorSummary> {
  /**
   * Total number of commits in the date range.
   *
   * @generated from field: int64 total_commits = 1;
   */
  totalCommits = protoInt64.zero;

  /**
   * Total lines added across all commits.
   *
   * @generated from field: int64 total_lines_added = 2;
   */
  totalLinesAdded = protoInt64.zero;

  /**
   * Total lines removed across all commits.
   *
   * @generated from field: int64 total_lines_removed = 3;
   */
  totalLinesRemoved = protoInt64.zero;

  /**
   * Number of distinct authors (by author_hash).
   *
   * @generated from field: int64 distinct_authors = 4;
   */
  distinctAuthors = protoInt64.zero;

  /**
   * Per-tool breakdown of contribution stats.
   *
   * @generated from field: repeated gitpod.v1.ToolBreakdown by_tool = 5;
   */
  byTool: ToolBreakdown[] = [];

  constructor(data?: PartialMessage<CoAuthorSummary>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CoAuthorSummary";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "total_commits", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "total_lines_added", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "total_lines_removed", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "distinct_authors", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 5, name: "by_tool", kind: "message", T: ToolBreakdown, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CoAuthorSummary {
    return new CoAuthorSummary().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CoAuthorSummary {
    return new CoAuthorSummary().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CoAuthorSummary {
    return new CoAuthorSummary().fromJsonString(jsonString, options);
  }

  static equals(a: CoAuthorSummary | PlainMessage<CoAuthorSummary> | undefined, b: CoAuthorSummary | PlainMessage<CoAuthorSummary> | undefined): boolean {
    return proto3.util.equals(CoAuthorSummary, a, b);
  }
}

/**
 * ToolBreakdown contains stats for a single AI tool (or human).
 *
 * @generated from message gitpod.v1.ToolBreakdown
 */
export class ToolBreakdown extends Message<ToolBreakdown> {
  /**
   * The tool these stats are for.
   *
   * @generated from field: gitpod.v1.CoAuthorTool tool = 1;
   */
  tool = CoAuthorTool.UNSPECIFIED;

  /**
   * Number of commits attributed to this tool.
   *
   * @generated from field: int64 commits = 2;
   */
  commits = protoInt64.zero;

  /**
   * Lines added by this tool.
   *
   * @generated from field: int64 lines_added = 3;
   */
  linesAdded = protoInt64.zero;

  /**
   * Lines removed by this tool.
   *
   * @generated from field: int64 lines_removed = 4;
   */
  linesRemoved = protoInt64.zero;

  /**
   * Distinct authors who used this tool.
   *
   * @generated from field: int64 distinct_authors = 5;
   */
  distinctAuthors = protoInt64.zero;

  constructor(data?: PartialMessage<ToolBreakdown>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ToolBreakdown";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "tool", kind: "enum", T: proto3.getEnumType(CoAuthorTool) },
    { no: 2, name: "commits", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "lines_added", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "lines_removed", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 5, name: "distinct_authors", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ToolBreakdown {
    return new ToolBreakdown().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ToolBreakdown {
    return new ToolBreakdown().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ToolBreakdown {
    return new ToolBreakdown().fromJsonString(jsonString, options);
  }

  static equals(a: ToolBreakdown | PlainMessage<ToolBreakdown> | undefined, b: ToolBreakdown | PlainMessage<ToolBreakdown> | undefined): boolean {
    return proto3.util.equals(ToolBreakdown, a, b);
  }
}

/**
 * CoAuthorTimeBucket contains stats for a single time period.
 *
 * @generated from message gitpod.v1.CoAuthorTimeBucket
 */
export class CoAuthorTimeBucket extends Message<CoAuthorTimeBucket> {
  /**
   * Start of this time bucket.
   *
   * @generated from field: google.protobuf.Timestamp start_time = 1;
   */
  startTime?: Timestamp;

  /**
   * Per-tool breakdown for this bucket.
   *
   * @generated from field: repeated gitpod.v1.ToolBreakdown by_tool = 2;
   */
  byTool: ToolBreakdown[] = [];

  /**
   * Total lines added in this bucket (across all tools).
   *
   * @generated from field: int64 total_lines_added = 3;
   */
  totalLinesAdded = protoInt64.zero;

  /**
   * Total lines removed in this bucket (across all tools).
   *
   * @generated from field: int64 total_lines_removed = 4;
   */
  totalLinesRemoved = protoInt64.zero;

  /**
   * Ratio of AI-assisted lines added to total lines added (0.0–1.0).
   *
   * @generated from field: double ai_ratio = 5;
   */
  aiRatio = 0;

  /**
   * Total number of commits in this bucket (across all tools).
   *
   * @generated from field: int64 total_commits = 6;
   */
  totalCommits = protoInt64.zero;

  constructor(data?: PartialMessage<CoAuthorTimeBucket>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CoAuthorTimeBucket";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "start_time", kind: "message", T: Timestamp },
    { no: 2, name: "by_tool", kind: "message", T: ToolBreakdown, repeated: true },
    { no: 3, name: "total_lines_added", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "total_lines_removed", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 5, name: "ai_ratio", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 6, name: "total_commits", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CoAuthorTimeBucket {
    return new CoAuthorTimeBucket().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CoAuthorTimeBucket {
    return new CoAuthorTimeBucket().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CoAuthorTimeBucket {
    return new CoAuthorTimeBucket().fromJsonString(jsonString, options);
  }

  static equals(a: CoAuthorTimeBucket | PlainMessage<CoAuthorTimeBucket> | undefined, b: CoAuthorTimeBucket | PlainMessage<CoAuthorTimeBucket> | undefined): boolean {
    return proto3.util.equals(CoAuthorTimeBucket, a, b);
  }
}

/**
 * EnableProjectInsightsRequest enables co-author insights for a project.
 *
 * @generated from message gitpod.v1.EnableProjectInsightsRequest
 */
export class EnableProjectInsightsRequest extends Message<EnableProjectInsightsRequest> {
  /**
   * Project to enable insights for.
   *
   * @generated from field: string project_id = 1;
   */
  projectId = "";

  constructor(data?: PartialMessage<EnableProjectInsightsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.EnableProjectInsightsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "project_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): EnableProjectInsightsRequest {
    return new EnableProjectInsightsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): EnableProjectInsightsRequest {
    return new EnableProjectInsightsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): EnableProjectInsightsRequest {
    return new EnableProjectInsightsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: EnableProjectInsightsRequest | PlainMessage<EnableProjectInsightsRequest> | undefined, b: EnableProjectInsightsRequest | PlainMessage<EnableProjectInsightsRequest> | undefined): boolean {
    return proto3.util.equals(EnableProjectInsightsRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.EnableProjectInsightsResponse
 */
export class EnableProjectInsightsResponse extends Message<EnableProjectInsightsResponse> {
  constructor(data?: PartialMessage<EnableProjectInsightsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.EnableProjectInsightsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): EnableProjectInsightsResponse {
    return new EnableProjectInsightsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): EnableProjectInsightsResponse {
    return new EnableProjectInsightsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): EnableProjectInsightsResponse {
    return new EnableProjectInsightsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: EnableProjectInsightsResponse | PlainMessage<EnableProjectInsightsResponse> | undefined, b: EnableProjectInsightsResponse | PlainMessage<EnableProjectInsightsResponse> | undefined): boolean {
    return proto3.util.equals(EnableProjectInsightsResponse, a, b);
  }
}

/**
 * GetProjectInsightsStatusRequest checks whether insights is enabled for a project.
 *
 * @generated from message gitpod.v1.GetProjectInsightsStatusRequest
 */
export class GetProjectInsightsStatusRequest extends Message<GetProjectInsightsStatusRequest> {
  /**
   * Project to check.
   *
   * @generated from field: string project_id = 1;
   */
  projectId = "";

  constructor(data?: PartialMessage<GetProjectInsightsStatusRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetProjectInsightsStatusRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "project_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetProjectInsightsStatusRequest {
    return new GetProjectInsightsStatusRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetProjectInsightsStatusRequest {
    return new GetProjectInsightsStatusRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetProjectInsightsStatusRequest {
    return new GetProjectInsightsStatusRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetProjectInsightsStatusRequest | PlainMessage<GetProjectInsightsStatusRequest> | undefined, b: GetProjectInsightsStatusRequest | PlainMessage<GetProjectInsightsStatusRequest> | undefined): boolean {
    return proto3.util.equals(GetProjectInsightsStatusRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.GetProjectInsightsStatusResponse
 */
export class GetProjectInsightsStatusResponse extends Message<GetProjectInsightsStatusResponse> {
  /**
   * Whether co-author insights is enabled for the project.
   *
   * @generated from field: bool enabled = 1;
   */
  enabled = false;

  constructor(data?: PartialMessage<GetProjectInsightsStatusResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetProjectInsightsStatusResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetProjectInsightsStatusResponse {
    return new GetProjectInsightsStatusResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetProjectInsightsStatusResponse {
    return new GetProjectInsightsStatusResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetProjectInsightsStatusResponse {
    return new GetProjectInsightsStatusResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetProjectInsightsStatusResponse | PlainMessage<GetProjectInsightsStatusResponse> | undefined, b: GetProjectInsightsStatusResponse | PlainMessage<GetProjectInsightsStatusResponse> | undefined): boolean {
    return proto3.util.equals(GetProjectInsightsStatusResponse, a, b);
  }
}

